import { render, staticRenderFns } from "./UserDataBuyBilling.vue?vue&type=template&id=2d8c3a3e&"
import script from "./UserDataBuyBilling.vue?vue&type=script&lang=js&"
export * from "./UserDataBuyBilling.vue?vue&type=script&lang=js&"
import style0 from "./UserDataBuyBilling.vue?vue&type=style&index=0&id=2d8c3a3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports